import { authenticatedApiRequest, cleanEmptyFields } from "./core";
import type { PaginatedResponse } from "./core";
import type { Label, LabelDetails, CreateLabel } from "@/types";

export interface PaginatedLabelsResponse extends PaginatedResponse {
  results: Label[];
}

export const labelsApi = {
  getLabels: async (): Promise<PaginatedLabelsResponse> => {
    return authenticatedApiRequest<PaginatedLabelsResponse>("/accounts/labels");
  },
  getLabel: async (id: string): Promise<LabelDetails> => {
    return authenticatedApiRequest<LabelDetails>(`/accounts/labels/${id}`);
  },
  createLabel: async (label: CreateLabel): Promise<Label> => {
    return authenticatedApiRequest<Label>("/accounts/labels", {
      method: "POST",
      body: JSON.stringify(cleanEmptyFields(label)),
    });
  },
  updateLabel: async (id: string, label: Partial<CreateLabel>): Promise<LabelDetails> => {
    return authenticatedApiRequest<LabelDetails>(`/accounts/labels/${id}`, {
      method: "PATCH",
      body: JSON.stringify(label),
    });
  },
  deleteLabel: async (id: string): Promise<void> => {
    await authenticatedApiRequest<void>(`/accounts/labels/${id}`, {
      method: "DELETE",
    });
  },
};
